import type { LessonPhase } from '../../lib/liveLessonTypes';
import { Button } from '../ui';
import CollapsibleTile from './CollapsibleTile';

type LessonPhaseTimelineProps = {
  phases: LessonPhase[];
  activePhaseId: string | null;
  onSelect: (phaseId: string) => void;
};

export default function LessonPhaseTimeline({ phases, activePhaseId, onSelect }: LessonPhaseTimelineProps) {
  return (
    <CollapsibleTile title="Unterrichtsphase" defaultOpen>
      <div className="flex flex-wrap gap-2">
        {phases.map((phase) => (
          <Button
            key={phase.id}
            size="sm"
            variant={activePhaseId === phase.id ? 'primary' : 'outline'}
            onClick={() => onSelect(phase.id)}
          >
            {phase.label}
          </Button>
        ))}
      </div>
    </CollapsibleTile>
  );
}
